import CalendarSolidSVG from "@design-system/ui-icons/vanilla/CalendarSolid"
import { createIcon } from "../createIcon"

export const CalendarSolidIcon = createIcon(CalendarSolidSVG)
